(() => {
  'use strict';
  const config = document.querySelector('[data-ew-collection-return]');
  if (!config) return;
  const key = 'ew.collectionVisits.v1';
  const maxAge = 6 * 60 * 60 * 1000;
  const productHandle = url => url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
  const collectionURL = value => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname) && !url.pathname.includes('/products/') ? url : null;
    } catch (_) { return null; }
  };
  const readVisits = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
      if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return {};
      return Object.fromEntries(Object.entries(saved).filter(([, visit]) => visit && Number.isFinite(visit.at) && Date.now() - visit.at < maxAge && collectionURL(visit.url)));
    } catch (_) { return {}; }
  };
  const storeVisit = visit => {
    try {
      const visits = readVisits();
      const token = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      visits[token] = visit;
      const recent = Object.entries(visits).sort((a, b) => b[1].at - a[1].at).slice(0, 30);
      sessionStorage.setItem(key, JSON.stringify(Object.fromEntries(recent)));
      return token;
    } catch (_) { return null; }
  };
  const main = document.querySelector('#MainContent');

  if (config.dataset.pageType === 'collection' && main) {
    const capture = event => {
      const link = event.target.closest('a[href]');
      if (!link || !main.contains(link) || link.hasAttribute('download')) return;
      const url = new URL(link.href, location.origin);
      const handle = productHandle(url);
      if (url.origin !== location.origin || !handle) return;
      const current = collectionURL(location.href);
      const base = collectionURL(config.dataset.collectionUrl);
      if (!current || !base) return;
      current.hash = '';
      const card = link.closest('.product-card-wrapper') || link;
      const token = storeVisit({ url: current.pathname + current.search, title: config.dataset.collectionTitle || 'Cake toppers', product: handle, y: window.scrollY, x: window.scrollX, offset: card.getBoundingClientRect().top, inGrid: Boolean(link.closest('#product-grid')), at: Date.now() });
      // Shopify can still render the collection breadcrumb without browser storage.
      url.pathname = base.pathname.replace(/\/$/, '') + '/products/' + handle;
      url.searchParams.delete('ew_from');
      if (token) url.searchParams.set('ew_from', token);
      link.href = url.pathname + url.search + url.hash;
    };
    // Delegation covers products replaced by Shopify filtering and pagination.
    main.addEventListener('pointerdown', capture, true);
    main.addEventListener('click', capture, true);
    main.addEventListener('auxclick', capture, true);
    main.addEventListener('contextmenu', capture, true);

    const token = location.hash.match(/^#ew-return=([a-z0-9-]+)$/)?.[1];
    const visit = token && readVisits()[token];
    const savedURL = visit && collectionURL(visit.url);
    if (!savedURL || savedURL.pathname !== location.pathname || savedURL.search !== location.search) return;
    if (!Number.isFinite(visit.y) || !Number.isFinite(visit.offset)) return;
    const previousRestoration = history.scrollRestoration;
    history.scrollRestoration = 'manual';
    history.replaceState(history.state, '', location.pathname + location.search);
    let stopped = false;
    let observer;
    let timer;
    const stop = () => {
      if (stopped) return;
      stopped = true;
      observer?.disconnect();
      clearTimeout(timer);
      history.scrollRestoration = previousRestoration;
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.removeEventListener(type, stop, true));
      window.removeEventListener('load', restore);
    };
    const restore = () => {
      if (stopped) return;
      const link = [...main.querySelectorAll('#product-grid a[href]')].find(link => productHandle(new URL(link.href, location.origin)) === visit.product);
      const card = visit.inGrid ? link?.closest('.product-card-wrapper') : null;
      const y = card ? window.scrollY + card.getBoundingClientRect().top - visit.offset : visit.y;
      window.scrollTo({ left: Number.isFinite(visit.x) ? visit.x : 0, top: Math.max(0, y), behavior: 'instant' });
    };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, stop, { capture: true, passive: true }));
    window.addEventListener('pagehide', stop, { once: true });
    window.addEventListener('load', restore, { once: true });
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(restore);
      observer.observe(main);
    }
    restore();
    requestAnimationFrame(restore);
    if (document.fonts) document.fonts.ready.then(restore);
    timer = setTimeout(stop, 2500);
  }

  if (config.dataset.pageType === 'product') {
    const token = new URL(location.href).searchParams.get('ew_from');
    const visit = token && readVisits()[token];
    if (!visit || visit.product !== config.dataset.productHandle) return;
    const url = collectionURL(visit.url);
    if (!url) return;
    const all = document.querySelector('[data-ew-all-collections]');
    const parent = document.querySelector('[data-ew-parent-collection]');
    const separator = document.querySelector('[data-ew-parent-separator]');
    if (!all || !parent || !separator) return;
    const broad = /\/collections\/(cake-toppers|all)\/?$/.test(url.pathname);
    const target = broad ? all : parent;
    url.hash = 'ew-return=' + token;
    target.href = url.pathname + url.search + url.hash;
    target.textContent = broad ? 'Cake toppers' : visit.title;
    target.setAttribute('aria-label', 'Back to ' + (broad ? 'all cake toppers' : visit.title) + ', with your browsing position saved');
    parent.hidden = broad;
    separator.hidden = broad;
  }
})();
